export class BocciaturaPresidioTIM {
    
   
    noteBocciatura!:string;
    
    
  }
  